export default __webpack_public_path__ + "static/source-sans-pro-latin-600-normal-d377fd9830de222773d7fa1b539799db.woff";